import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query reportBuilderReports {
    cat {
      reporting {
        builder {
          report {
            many {
              _id
              title
              model
              fields
              createdAt
              updatedAt
              _createdBy {
                _id
                name
              }
              _updatedBy {
                _id
                name
              }
            }
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type ReportBuilderReports = NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['reporting']>['builder']>['report']>['many']>

const useReportBuilderReports = (options?: UseGraphqlOptions<TData>): ReportBuilderReports => {
  const { data } = useGraphQL(document, {}, options)
  return data?.cat?.reporting?.builder?.report?.many ?? []
}

export { useReportBuilderReports, document as reportBuilderReportsDocument }
